class ProductOffers {
  constructor() {
    this.init();
  }

  init() {
    document.addEventListener('DOMContentLoaded', function() {
      // Open modal
      document.querySelectorAll('.product-offers__view-all').forEach(button => {
        button.addEventListener('click', function(e) {
          e.preventDefault();
          document.getElementById('OffersModal').setAttribute('aria-hidden', 'false');
          document.body.style.overflow = 'hidden';
        });
      });

      // Close modal
      document.querySelectorAll('.modal__close').forEach(button => {
        button.addEventListener('click', function() {
          this.closest('.modal').setAttribute('aria-hidden', 'true');
          document.body.style.overflow = '';
        });
      });

      // Close on outside click
      document.querySelectorAll('.modal').forEach(modal => {
        modal.addEventListener('click', function(e) {
          if (e.target === this) {
            this.setAttribute('aria-hidden', 'true');
            document.body.style.overflow = '';
          }
        });
      });

      // Close on Escape key
      document.addEventListener('keydown', function(e) {
        if (e.key === 'Escape') {
          document.querySelectorAll('.modal[aria-hidden="false"]').forEach(modal => {
            modal.setAttribute('aria-hidden', 'true');
            document.body.style.overflow = '';
          });
        }
      });
    });
  }
}

// Initialize the product offers functionality
document.addEventListener('DOMContentLoaded', () => {
  new ProductOffers();
});
